// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"a2d5e2b0","658":"a2d5e2b0","686":"a2d5e2b0"}[chunkId] + ".chunk.css";
};